import {
    GET_EVALUATION_RULES,
    GET_SHIFT_RULES,
    GET_MEASUREMENT_RULES
} from '../actions/MeasurementRuleAction'

const initialState = {
    evaluations: [],
    evaluations_pageSize: 20,
    evaluations_total: 0,
    evaluations_totalPages: 0,
    evaluations_item: 0,
    evaluations_currentPage: 0,
    shifts: [],
    shifts_pageSize: 20,
    shifts_total: 0,
    shifts_totalPages: 0,
    shifts_item: 0,
    shifts_currentPage: 0,
    measurments: [],
    measurments_pageSize: 20,
    measurments_total: 0,
    measurments_totalPages: 0,
    measurments_item: 0,
    measurments_currentPage: 0,
}

const MeasurementRuleReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_EVALUATION_RULES: {
            return {
                ...state,
                evaluations: action.payload.content,
                evaluations_pageSize: action.payload.size,
                evaluations_total: action.payload.totalElements,
                evaluations_totalPages: action.payload.totalPages,
                evaluations_item: action.payload.numberOfElements,
                evaluations_currentPage: action.payload.number
            }
        }
        case GET_SHIFT_RULES: {
            return {
                ...state,
                shifts: action.payload.content,
                shifts_pageSize: action.payload.size,
                shifts_total: action.payload.totalElements,
                shifts_totalPages: action.payload.totalPages,
                shifts_item: action.payload.numberOfElements,
                shifts_currentPage: action.payload.number
            }
        }
        case GET_MEASUREMENT_RULES: {
            return {
                ...state,
                measurments: action.payload.content,
                measurments_pageSize: action.payload.size,
                measurments_total: action.payload.totalElements,
                measurments_totalPages: action.payload.totalPages,
                measurments_item: action.payload.numberOfElements,
                measurments_currentPage: action.payload.number
            }
        }
        
        default: {
            return state
        }
    }
}

export default MeasurementRuleReducer
